<template>
  <div class="auth-layout text-center">
    <div class="language-block">
      <div class="language-item" :class="this.$store.state.language == 'ru' ? 'active':''" @click="setLanguage('ru')">
        RU
      </div>
      <div class="separator"></div>
      <div class="language-item" :class="this.$store.state.language == 'en' ? 'active':''" @click="setLanguage('en')">
        UK
      </div>
    </div>
    <router-view/>
  </div>
</template>

<style scoped>
  .language-block{
    position: absolute;
    top: 30px;
    right: 100px;
  }
  .auth-layout{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    background-color: #F7F5F9;
  }
</style>

<script>
import language from "../i18n";

export default {
  name: 'empty-layout',
  data: function(){
    return{
      toggle: true,
      dropDown: false,
    }
  },
  methods: {
    setLanguage: function(name){
      this.$store.state.language = name;
      language.locale = name;
    },
  }
}
</script>